import { useEditor, EditorContent } from '@tiptap/react'
import { useEffect } from 'react'

import { MENTIONS_EDITOR_EXTENSIONS } from './mentions.config'

export function MentionDescPreview({ content }: { content: string }) {
  const editor = useEditor({
    extensions: MENTIONS_EDITOR_EXTENSIONS,
    editable: false,
    shouldRerenderOnTransaction: false,
    immediatelyRender: false,
    content: content,
  })

  // Keep editor content in sync when the `content` prop changes
  useEffect(() => {
    if (!editor) return

    const current = editor.getHTML()

    // Avoid unnecessary updates: only set if different
    if (current !== content) {
      queueMicrotask(() => {
        editor.commands.setContent(content, {
          emitUpdate: false,
        })
      })
    }
  }, [content, editor])

  if (!editor) return null

  return <EditorContent className="px-2 py-1" editor={editor} />
}
